import { useState } from "react";
import { Card } from "antd";
import { useEffect } from "react";
import { ModulButtonModal } from "src/enitities/Integration";

const { Meta } = Card;

export default function IntegrationModulBank({ query, websocket }) {
  // eslint-disable-next-line no-unused-vars
  const [state, setState] = useState({});

  useEffect(() => {}, []);

  return (
    <Card
      style={{ width: 250 }}
      cover={
        <div
          style={{
            display: "flex",
            height: 250,
            justifyContent: "center",
            alignItems: "center",
            backgroundColor: "#2042ab",
            color: "white",
          }}>
          <h3>Модуль банк</h3>
        </div>
      }
      actions={[<ModulButtonModal name="Установить виджет" query={query} websocket={websocket} />]}>
      <Meta title="Модуль Банк" description={""} />
    </Card>
  );
}
